import axios from 'axios';
import env from '../env';

const httpCacheInst = () => {
	const myAxios = axios.create({
    baseURL: env.cacheUrl,
    timeout: 30000,
    headers: {
		'ocp-apim-subscription-key': localStorage.getItem('token'),
    }
	});

	myAxios.interceptors.response.use(function (response) {
		return response;
	}, function (error) {
		if (error.response.status === 401) {
			localStorage.removeItem('token');
			window.location = '/login';
		}
		return Promise.reject(error);
	});

	return myAxios;
}

export default httpCacheInst;